import { insertIf } from '@backmarket/utils/collection/insertIf'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTES as AUTH_ROUTES } from '~/scopes/auth/routes'

import type { Features } from '../../features'

import { ROUTE_NAMES } from './constants'

const buybackRoutes: RouteRecordRaw[] = [
  {
    name: ROUTE_NAMES.DEVICE_ASSESSMENT,
    path: '/:locale/buyback-funnel/device/:slug/:id',
    component: () => import('./pages/DeviceAssessment.vue'),
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
  {
    name: ROUTE_NAMES.OFFER,
    path: '/:locale/buyback-funnel/device/:slug/:id/offer/:offerId',
    component: () => import('./pages/Offer.vue'),
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
  {
    name: ROUTE_NAMES.NO_OFFER,
    path: '/:locale/buyback-funnel/device/:slug/:id/no-offer',
    component: () => import('./pages/NoOffer.vue'),
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
  {
    name: ROUTE_NAMES.BANK,
    path: '/:locale/buyback-funnel/device/:slug/:id/offer/:offerId/bank',
    component: () => import('./pages/Bank.vue'),
    meta: {
      disableClientSideNavigation: () => true,
      auth: {
        required: true,
        redirection: {
          name: AUTH_ROUTES.AUTH.LOGIN,
        },
      },
    },
  },
  {
    name: ROUTE_NAMES.ADDRESS,
    path: '/:locale/buyback-funnel/device/:slug/:id/offer/:offerId/address',
    component: () => import('./pages/Address.vue'),
    meta: {
      disableClientSideNavigation: () => true,
    },
    // TODO: BBACK-6047 Add auth guard
    /* meta: {
      auth: {
        required: true,
      },
    }, */
  },
]

export default ({ features }: { features: Features }): RouteRecordRaw[] => {
  const isBuybackEnabled = features.buyback?.enabled

  return [
    // Buyback Routes are exposed on eligible countries only
    ...insertIf(isBuybackEnabled, buybackRoutes),
  ]
}
